module.exports = __webpack_public_path__ + "img/pr-1.5b63f759.png";